<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>医学影像解剖图谱</h1>
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 循环图文区块 -->
          <div v-for="(item,index) in fullText" :key="index" class="text-block">
            <h2 v-if="index != 0" class="title_T">{{item.title}}</h2>
            <div class="text-wrap">
              <p class="text-content">{{item.content}}</p>
            </div>
            <div class="main-banner gifLimit">
              <img
                :src="item.img"
                :alt="item.altText"
                class="banner-img"
                loading="lazy"
                decoding="async"
              />
              <div class="banner-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PullDown from "@/components/home/pullDown.vue"
export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "ImageAtlasSystem",
  components: {
    PullDown
  },
  data(){
    return{
      wWidth: window.innerWidth,
      fullText: [
        {
          content: '“影像解剖图谱”软件以影像图谱为核心，功能强大，数据丰富，内容专业，是一款医学影像解剖学习平台，现已同步开发APP端和PC端，适用于医疗和相关专业从业者。',
          img: require("@/assets/atlas.jpg"),
          altText: "医学影像解剖图谱系统首页展示，断层解剖学习软件PC与移动端界面"
        },{
          title: '——海量影像病例数据库——',
          content: '本软件与各大医学院校、医院合作 ，汇集了众多医生、护士、医学从业人员等生命科学领域的专业人士，收集大量最新设备拍摄的优质影像学图谱50万张，覆盖60万+精确的解剖结构，积极打造《影像解剖图谱病例数据库》。',
          img: require("@/assets/atlas1.jpg"),
          altText: "海量医学影像病例数据库，CT、MRI断层解剖影像资源库展示"
        },{
          title: '——结构清晰标注——',
          content: '大量真实人体断层解剖数据均为高清精准的解剖图，每张图谱均为经验丰富的医生或教授清晰标注与讲解。',
          img: require("@/assets/atlasGif.gif"),
          altText: "人体断层解剖图像交互式标注演示GIF，解剖结构标识教学演示"
        },{
          title: '——完整影像断层解剖图集——',
          content: '大量真实人体断层解剖数据均为高清精准的解剖图，每张图谱均为经验丰富的医生或教授清晰标注与讲解。',
          img: require("@/assets/atlas3.jpg"),
          altText: "全套人体断层解剖高清图集，放射解剖教学图谱展示"
        },{
          title: '——全身不同方位断层解剖——',
          content: '图谱部分涵盖了包括断层解剖、CT解剖、MRI（磁共振成像）、造影以及医学插图等多个方面，全面覆盖了人体各个部位和系统。丰富的图谱内容为用户提供了直观、全面的学习资料，有助于用户更深入地理解和掌握医学影像解剖知识。',
          img: require("@/assets/atlasGif2.gif"),
          altText: "人体轴位、矢状位、冠状位多方位断层影像切换演示动画"
        },{
          title: '——交互式学习——',
          content: '软件以影像图谱为核心，每个层面，冠、矢、轴等都具备详细的结构标注点，用户可以滑动每一帧查看更为细致的结构点信息。',
          img: require("@/assets/atlasGif3.gif"),
          altText: "交互式影像解剖学习操作演示，逐层浏览人体断层影像"
        },
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  }
}
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 48px;
    width: 100%;
    margin: auto;
  }

  .text-block {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .title_T {
    line-height: 2.2;
    color: #2563AF;
    font-size: 1.15rem;
    font-weight: 600;
    margin: 0;
  }

  // 全局统一标准文字样式（全系列页面共用）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 0;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // 图片统一大图样式
  .gifLimit.main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    max-width: 834px;
    width: 100%;
    margin: 0 auto;

    @media only screen and (max-width: 767px){
      max-width: 100%;
    }
  }
  .banner-img {
    width: 100%;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }
}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
        }
        .title_T {
          color: #60a5fa;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>